/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Sort direction : ASC, DESC
 */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}
